export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LkHeader.vue?vue&type=template&id=3396ddde&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/header/LkHeader.vue?vue&type=template&id=3396ddde&
// module id = 1582
// module chunks = 0